import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  LineChart,
  Line,
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer
} from "recharts";

import { FiTrendingUp, FiShoppingBag, FiUsers } from "react-icons/fi";

export default function ReportData() {

  // آمار بالا
  const stats = {
    totalOrders: 1240,
    monthIncome: 58_400_000,
    newCustomers: 87
  };

  // داده‌های هفتگی فروش (Bar Chart)
  const weeklySales = [
    { day: "شنبه", value: 120 },
    { day: "یکشنبه", value: 240 },
    { day: "دوشنبه", value: 180 },
    { day: "سه‌شنبه", value: 200 },
    { day: "چهارشنبه", value: 310 },
    { day: "پنجشنبه", value: 450 },
    { day: "جمعه", value: 380 }
  ];

  // روند سفارش ماه (Line Chart)
  const monthlyOrders = [
    { week: "هفته 1", orders: 110 },
    { week: "هفته 2", orders: 160 },
    { week: "هفته 3", orders: 220 },
    { week: "هفته 4", orders: 240 }
  ];

  // دسته‌بندی غذاها (Pie Chart)
  const foodTypes = [
    { name: "پیتزا", value: 25 },
    { name: "برگر", value: 20 },
    { name: "پاستا", value: 15 },
    { name: "سالاد", value: 10 },
    { name: "غذای ایرانی", value: 30 }
  ];

  const colors = ["#6366F1", "#10B981", "#F59E0B", "#EF4444", "#3B82F6"];

  return (
    <div className="p-6 space-y-10">

      {/* ---------- بخش آمار کلی ---------- */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
        
        <div className="bg-white border shadow rounded-xl p-5 flex items-center gap-4">
          <FiShoppingBag className="text-primary text-3xl" />
          <div>
            <p className="text-gray-500 text-sm">کل سفارش‌ها</p>
            <p className="text-xl font-bold">{stats.totalOrders}</p>
          </div>
        </div>

        <div className="bg-white border shadow rounded-xl p-5 flex items-center gap-4">
          <FiTrendingUp className="text-green-600 text-3xl" />
          <div>
            <p className="text-gray-500 text-sm">درآمد این ماه</p>
            <p className="text-xl font-bold">{stats.monthIncome.toLocaleString()} تومان</p>
          </div>
        </div>

        <div className="bg-white border shadow rounded-xl p-5 flex items-center gap-4">
          <FiUsers className="text-blue-600 text-3xl" />
          <div>
            <p className="text-gray-500 text-sm">مشتری‌های جدید</p>
            <p className="text-xl font-bold">{stats.newCustomers}</p>
          </div>
        </div>
      </div>

      {/* ---------- نمودار فروش هفتگی ---------- */}
      <div className="bg-white border shadow rounded-xl p-6">
        <h3 className="font-bold mb-4">فروش هفتگی</h3>
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={weeklySales}>
            <XAxis dataKey="day" />
            <YAxis />
            <Tooltip />
            <CartesianGrid strokeDasharray="3 3" />
            <Bar dataKey="value" fill="#6366F1" radius={[6, 6, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>

      {/* ---------- ترند سفارش‌های ماه ---------- */}
      <div className="bg-white border shadow rounded-xl p-6">
        <h3 className="font-bold mb-4">روند سفارش‌های ماه</h3>
        <ResponsiveContainer width="100%" height={300}>
          <LineChart data={monthlyOrders}>
            <XAxis dataKey="week" />
            <YAxis />
            <Tooltip />
            <Line type="monotone" dataKey="orders" stroke="#10B981" strokeWidth={3} />
          </LineChart>
        </ResponsiveContainer>
      </div>

      {/* ---------- دسته‌بندی غذاها ---------- */}
      <div className="bg-white border shadow rounded-xl p-6">
        <h3 className="font-bold mb-4">پرفروش‌ترین دسته‌های غذایی</h3>
        <ResponsiveContainer width="100%" height={300}>
          <PieChart>
            <Pie
              data={foodTypes}
              dataKey="value"
              nameKey="name"
              outerRadius={110}
              label
            >
              {foodTypes.map((entry, index) => (
                <Cell key={index} fill={colors[index]} />
              ))}
            </Pie>
          </PieChart>
        </ResponsiveContainer>
      </div>

    </div>
  );
}
